export default __webpack_public_path__ + "static/NotoSans-BoldItalic.subset-3b8bc9fa033d70fff62d42702ee1fde1.woff";